const RefinementError = Object.freeze({
  NO_MATERIAL_CHANGE: 'no_material_change',
  REQUEST_TIMEOUT: 'refinement_timeout',
  REFINEMENT_FAILED: 'refinement_failed',
} as const);

export type RefinementError = (typeof RefinementError)[keyof typeof RefinementError];

export default RefinementError;
